import {
  SelectCuenta,
  SelectMoneda,
  type CuentasProp,
} from "@/cuentas/adminSelects";
import { useConfigContext } from "@/state/configContext";
import { formatMoney, groupBy } from "@/helpers/helpers";
import { useAdminContext } from "@/state/adminContext";
import { GET } from "@/state/api";
import { POST, queryClient, server } from "@/state/server";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/admin/cuentas")({
  component: RouteComponent,
  loader: () => GET("/admin/cuentas/saldos"),
});

function RouteComponent() {
  const { admin } = useAdminContext();
  const data = Route.useLoaderData();

  const saldos = Object.entries(
    groupBy(
      data.saldos.filter((x) => Math.abs(x.V) > 0.01),
      (s) => `${s.cuenta}`
    )
  );

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Cuenta</th>
              <th>Saldo</th>
            </tr>
          </thead>
          <tbody>
            {saldos.map(([id, s]) => (
              <tr key={id}>
                <td>
                  {s[0].temporada_id ? (
                    <Link
                      to="/admin/comisiones"
                      search={{ temporada_id: s[0].temporada_id }}
                    >
                      {s[0].cuenta}
                    </Link>
                  ) : (
                    s[0].cuenta
                  )}
                </td>
                <td>
                  {s.map((x) => `${formatMoney(x.V)} ${x.moneda}`).join(" / ")}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <a onClick={() => window.open(`${server}/admin/comisiones_dia`)}>
                  {" "}
                  Fotos vendidas hoy{" "}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {admin.permisos?.includes("contador") && (
        <Contaduria cuentas={data.cuentas} />
      )}
    </div>
  );
}

function Contaduria({ cuentas }: CuentasProp) {
  return (
    <ul>
      <li>
        <AgregarGasto cuentas={cuentas} />
      </li>
      <li>
        <AgregarMovimiento cuentas={cuentas} />
      </li>
      <li>
        <Planilla />
      </li>
    </ul>
  );
}

function AgregarGasto({ cuentas }: CuentasProp) {
  const config = useConfigContext();

  const [obs, setObs] = useState(""),
    [cuenta, setCuenta] = useState(cuentas[0].id),
    [valor, setValor] = useState(""),
    [moneda, setMoneda] = useState(config.moneda);

  return (
    <>
      Agregar gasto,&nbsp;
      <input
        value={obs}
        onChange={(e) => setObs(e.target.value)}
        placeholder="Obs"
      />
      <SelectCuenta cuentas={cuentas} value={cuenta} onChange={setCuenta} />
      &nbsp;
      <input
        value={valor}
        onChange={(e) => setValor(e.target.value)}
        size={7}
      />
      &nbsp;
      <SelectMoneda value={moneda} onChange={setMoneda} />
      <button
        onClick={() => {
          const res = POST("/admin/gasto", {
            obs,
            cuenta,
            valor: Number(valor),
            moneda,
          });
          setObs("");
          setCuenta(cuentas[0].id);
          setValor("");
          setMoneda(config.moneda);
          res.then(() =>
            queryClient.invalidateQueries({
              queryKey: ["/admin/cuentas/saldos"],
            })
          );
        }}
      >
        Enviar
      </button>
    </>
  );
}

function AgregarMovimiento({ cuentas }: CuentasProp) {
  const { moneda } = useConfigContext();
  const { monedas } = useAdminContext();

  // TODO: useForm?
  const [obs, setObs] = useState("");
  const [cuentaDe, setCuentaDe] = useState(cuentas[0].id);
  const [valorDe, setValorDe] = useState("");
  const [monedaDe, setMonedaDe] = useState(moneda);
  const [cuentaA, setCuentaA] = useState(cuentas[0].id);
  const [monedaA, setMonedaA] = useState(moneda);

  return (
    <>
      Agregar movimiento,&nbsp;
      <input
        value={obs}
        onChange={(e) => setObs(e.target.value)}
        placeholder="Obs"
      />
      <SelectCuenta cuentas={cuentas} value={cuentaDe} onChange={setCuentaDe} />
      &nbsp;
      <input
        value={valorDe}
        onChange={(e) => setValorDe(e.target.value)}
        size={7}
      />
      &nbsp;
      <SelectMoneda value={monedaDe} onChange={setMonedaDe} />
      &nbsp;a&nbsp;
      <SelectCuenta cuentas={cuentas} value={cuentaA} onChange={setCuentaA} />
      &nbsp;
      {formatMoney(
        (Number(valorDe) * monedas[monedaDe]) / monedas[monedaA] || 0,
        monedaA
      )}
      &nbsp;
      <SelectMoneda value={monedaA} onChange={setMonedaA} />
      &nbsp;
      <button
        onClick={() => {
          const res = POST("/admin/movimiento", {
            obs,
            cuenta_de: cuentaDe,
            valor_de: Number(valorDe),
            moneda_de: monedaDe,
            cuenta_a: cuentaA,
            moneda_a: monedaA,
          });
          setObs("");
          setCuentaDe(cuentas[0].id);
          setValorDe("");
          setMonedaDe(moneda);
          setCuentaA(cuentas[0].id);
          setMonedaA(moneda);
          res.then(() =>
            queryClient.invalidateQueries({
              queryKey: ["/admin/cuentas/saldos"],
            })
          );
        }}
      >
        Enviar
      </button>
    </>
  );
}

function Planilla() {
  return (
    <>
      <form action={`${server}/admin/cuentas/planilla`}>
        De&nbsp;
        <input
          type="date"
          name="desde"
          defaultValue={new Date().toJSON().slice(0, 7) + "-01"}
        />
        &nbsp;a&nbsp;
        <input
          type="date"
          name="hasta"
          defaultValue={new Date().toJSON().slice(0, 10)}
        />
        <input type="submit" value="Descargar planilla" />
      </form>
    </>
  );
}
